import { IIconProps } from "."

export default function MinusIcon(props: IIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" {...props}>
      <path d="M5 13v-2h14v2Z" />
    </svg>
  )
}
